import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { InputField, SelectField, TextAreaField } from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { getFormattedDate } from "../../../utils/DateUtils";
import { getUserName } from "../utils";
import { getNairaFormat } from "../../../utils/Utils";
import { StyledForm } from "../../../components/Form/FormComponents.styled";

// eslint-disable-next-line no-unused-vars
const CreatedAssetsForm = ({ leaseData, setLeaseData, updateLeaseObject }) => {
	const [formData, setFormData] = useState(leaseData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(leaseData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// console.log(formData);
		setLeaseData(formData);
		updateLeaseObject(formData);
	};

	return (
		<StyledForm onSubmit={handleSubmit}>
			<ActionSideBar leaseData={formData} handleCancel={handleCancel} />

			<div className='RightSection'>
				<FormAccordion title='Lease Information' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<label>DATE / TIME</label>
							<InputField
								name='createdAt'
								handleChange={handleInputChange}
								value={getFormattedDate(formData?.createdAt)}
							/>
						</div>

						<div className='form-group'>
							<label>INVESTOR</label>
							<InputField name='leasee' handleChange={handleInputChange} value={getUserName(formData)} />
						</div>

						<div className='form-group'>
							<label>LEASE TYPE</label>
							<SelectField
								name='leaseType'
								handleChange={handleInputChange}
								isEditable={isEditable}
								value={formData?.leaseType}
								options={["Quick Lease", "Sponsored Lease"]}
							/>
						</div>

						<div className='form-group'>
							<label>CATEGORY</label>
							<InputField
								name='productCategory'
								handleChange={handleInputChange}
								value={formData?.category}
							/>
						</div>

						<div className='form-group'>
							<label>ASSET</label>
							<InputField name='productName' handleChange={handleInputChange} value={formData?.productName} />
						</div>

						<div className='form-group'>
							<label>BRAND</label>
							<InputField name='brand' handleChange={handleInputChange} value={formData?.brand} />
						</div>

						<div className='form-group'>
							<label>MODEL</label>
							<InputField name='model' handleChange={handleInputChange} value={formData?.model} />
						</div>

						<div className='form-group'>
							<label>YEAR</label>
							<InputField name='year' handleChange={handleInputChange} value={formData?.year} />
						</div>

						<div className='form-group'>
							<label>CONDITION</label>
							<InputField name='condition' handleChange={handleInputChange} value={formData?.condition} />
						</div>

						<div className='form-group'>
							<label>COLOR</label>
							<InputField name='color' handleChange={handleInputChange} value={formData?.color} />
						</div>

						<div className='form-group'>
							<label>AMOUNT</label>
							<InputField
								name='amount'
								handleChange={handleInputChange}
								// isEditable={isEditable}
								value={getNairaFormat(formData?.amount)}
							/>
						</div>

						<div className='form-group'>
							<label>INVESTMENT TYPE</label>
							<InputField
								name='investmentType'
								handleChange={handleInputChange}
								// isEditable={isEditable}
								value={formData?.type === "full-investment" ? "Full Investment" : ""}
							/>
						</div>

						{/* <div className='form-group'>
							<label>LEASE TENURE</label>
							<InputField
								name='lease_tenure'
								handleChange={handleInputChange}
								isEditable={isEditable}
								value={formData?.lease_tenure}
							/>
						</div> */}

						<div className='form-group'>
							<label>LEASE STRUCTURE</label>
							<InputField
								name='leaseStructure'
								handleChange={handleInputChange}
								isEditable={isEditable}
								value={formData?.leaseStructure}
							/>
						</div>

						<div className='form-group'>
							<label>LEASE DURATION</label>
							<InputField
								name='leaseDuration'
								handleChange={handleInputChange}
								isEditable={isEditable}
								value={formData?.leaseDuration}
							/>
						</div>
					</div>
				</FormAccordion>

				<FormAccordion title='Product description' open={true}>
					<div className='form-group'>
						<TextAreaField
							name='product_desc'
							value={formData?.description || formData?.productId.description}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Key features'>
					<div className='form-group'>
						<TextAreaField
							name='product_features'
							value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Product specifications'>
					<div className='form-group'>
						<TextAreaField
							name='product_specs'
							value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
						/>
					</div>
				</FormAccordion>

				{/* <FormAccordion title='Identification' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<label>Type</label>
							<InputField name='idType' value={formData?.user?.investorProfile?.idType} />
						</div>

						<div className='form-group'>
							<label>NUMBER</label>
							<InputField name='idNumber' value={formData?.user?.investorProfile?.idNumber} />
						</div>

						<div className='form-group'>
							<label>EXPIRY DATE</label>
							<InputField name='idExpiryDate' value={formData?.user?.investorProfile?.idExpiryDate} />
						</div>

						<div className='form-group'>
							<FileGroup name='bank_statement_g1' value={formData?.user?.idCard} />
						</div>
					</div>
				</FormAccordion> */}

				{/* <FormAccordion title='Power of Attorney' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<SelectFieldStatus
								name='powerOfAttorney'
								handleChange={handleInputChange}
								value={formData?.user?.investorProfile?.powerOfAttorney}
								type={"success"}
							/>
						</div>
					</div>
				</FormAccordion> */}
			</div>
		</StyledForm>
	);
};

// Props Validation
CreatedAssetsForm.propTypes = {
	leaseData: PropTypes.object,
	setLeaseData: PropTypes.func,
	updateLeaseObject: PropTypes.func,
};

export default CreatedAssetsForm;
